export default "__VITE_ASSET__CfX5ME9w__"